import { Controller } from "@hotwired/stimulus";

// A tiny add/remove editor for a list of short text values (corpus `recommended` /
// `avoid` / `folk`). Each row is an <input> sharing the same `name` ending in `[]`, so
// Rails collects them into an array. An empty template row is cloned on "Add".
//
//   data-controller="list-editor"
//   <div data-list-editor-target="rows">…<input>…<button data-action="list-editor#remove">…</div>
//   <template data-list-editor-target="template"><input>…</template>
//   <button data-action="list-editor#add">Add</button>
export default class extends Controller {
  static targets = ["rows", "template"];

  add(event) {
    event.preventDefault();
    const fragment = this.templateTarget.content.cloneNode(true);
    this.rowsTarget.appendChild(fragment);
    const inputs = this.rowsTarget.querySelectorAll("input");
    inputs[inputs.length - 1]?.focus();
  }

  remove(event) {
    event.preventDefault();
    event.target.closest("[data-list-editor-row]")?.remove();
  }
}
